import React from 'react';

import {
  deviceSyncMergesContainerConfiguration,
  STATUS_OPEN,
} from '@totem/components/administration/deviceSyncMerges/containerConfiguration';
import DeviceSyncMergesContainer from '@totem/components/administration/deviceSyncMerges/DeviceSyncMergesContainer';
import DeviceSyncMergesLayout, {
  DeviceSyncMergesExtra,
} from '@totem/components/administration/deviceSyncMerges/DeviceSyncMergesLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

const DeviceSyncMergesPage = () => (
  <ContentLayout>
    <InputContainer
      filterConfig={deviceSyncMergesContainerConfiguration}
      defaultSort={{
        field: 'lastSeen',
        direction: 'descend',
      }}
      defaultFilters={[{ field: 'status', values: [STATUS_OPEN] }]}
      componentKey={'admin.deviceSyncMerges'}
    >
      <DeviceSyncMergesContainer>
        <IBCard
          isCovered
          title={'Device Sync Merges'}
          extra={<DeviceSyncMergesExtra />}
        >
          <DeviceSyncMergesLayout />
        </IBCard>
      </DeviceSyncMergesContainer>
    </InputContainer>
  </ContentLayout>
);

export default DeviceSyncMergesPage;
